var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.text
    ? _c("div", { ref: "foldTextWrapper", staticClass: "text-wrapper" }, [
        _c(
          "div",
          { class: _vm.textContainerClass, style: _vm.textContainerStyle },
          [
            _vm.isShowExpand
              ? _c(
                  "span",
                  { staticClass: "btn", on: { click: _vm.handleExpand } },
                  [_vm._v("展开")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isShowFold
              ? _c(
                  "span",
                  {
                    staticClass: "unfoldBtn",
                    on: {
                      click: function () {
                        return (_vm.checked = false)
                      },
                    },
                  },
                  [_vm._v("收起")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.contentUrl
              ? _c("a", { ref: "foldText", attrs: { href: _vm.contentUrl } }, [
                  _vm._v("\n            " + _vm._s(_vm.text) + "\n        "),
                ])
              : _c("span", { ref: "foldText", staticClass: "fold-text" }, [
                  _vm._v("\n            " + _vm._s(_vm.text) + "\n        "),
                ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }